import { apiRequest } from '../config/api';

export interface UpdateCalendarTypeData {
  calendarType: 'GREGORIAN' | 'JALALI';
}

export interface UpdateCalendarTypeResponse {
  success: boolean;
  account: any;
  message: string;
}

class AccountService {
  /**
   * Update calendar type for the current user's account
   * Uses user-facing endpoint that automatically detects account type
   */
  async updateCurrentAccountCalendarType(
    user: any,
    calendarType: 'GREGORIAN' | 'JALALI'
  ): Promise<UpdateCalendarTypeResponse> {
    if (!user?.id) {
      throw new Error('User ID is required');
    }
    
    // Use user-facing endpoint that handles both individual and corporate accounts
    return apiRequest(`/api/users/${user.id}/account/calendar-type`, 'PATCH', {
      calendarType,
    });
  }
}

export default new AccountService();

